import { faCamera, faPaperclip } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FormErrorMessage } from "../../components";
import { AppConstants, AudioSupportedType, FileSize } from "../../configs";
import { v4 as uuidv4 } from 'uuid';
import {
  ApiSchemaCallCenterMessageData,
  ApiSchemaRequestUpdateCallCenterMessage,
  MessageModel,
  MessageViewModel,
} from "../../models";
import {
  useFunctionalityCallCenterMessage,
  useFunctionalityCountry,
  useFunctionalityState,
} from "../../pages/hooks";

type Props = {
  show: boolean;
  handleShow: (value: boolean) => void;

  dataToEdit: MessageViewModel;
  setDataToEdit: (value: MessageViewModel) => void;
  onSaveHandler: (value: FormData, category?: string) => void;
};

export function ModalMessageEditModal(props: Props): JSX.Element {
  // console.log("ModalMessageEditModal has been shown");
  // console.log("Modal to edit message has been triggered");
  const { show, handleShow, dataToEdit, setDataToEdit, onSaveHandler } = props;
  // const { countryList } = useFunctionalityCountry();
  //const { onEditMessage } = useFunctionalityCallCenterMessage({ callCenterId });
  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm<MessageModel>();
  const [selectedAudioFile, setSelectedAudioFile] = React.useState('');
  const [audioValidationMsg, setAudioValidationMsg] = React.useState("");

  const modalHideHandler = () => {
    reset();
    handleShow(false);
    setSelectedAudioFile("");
    setAudioValidationMsg("");
  };


  useEffect(() => {
    //populate the form with new data
    reset({message: dataToEdit?.message});

  }, [dataToEdit, show]);



  const onEditHandler = (form: any) => {
    console.log("onEditHandler fired");
    form = {
      ...form,
      id: dataToEdit.id,
      title: dataToEdit.title,
      audioMediaKey: dataToEdit.audioMediaKey,
      category: dataToEdit.category,
      isDefault: dataToEdit.isDefault,
      isTtsEnabled: dataToEdit.isTtsEnabled,
    };
    const audioMediaKey = form.audioMediaKey;
    const body = new FormData();
    body.append("id", form.id);
    body.append("title", form.title);
    body.append("category", form.category);
    body.append("isDefault", form.isDefault);
    body.append("isTtsEnabled", form.isTtsEnabled);
    
    if (form.mediaFile) {
      console.log("we have a media file");
      const fileName = form.mediaFile.name;
      const fileExtension = fileName.substr(fileName.lastIndexOf('.'));
      body.append('mediaFile', form.mediaFile);

      if (!audioMediaKey) {
        console.log("audiomediakey not present");
        body.append('audioMediaKey', uuidv4());
      } else {
        console.log("audiomediakey IS present");

        const fileNameWithoutExtension = audioMediaKey.slice(
          0,
          audioMediaKey.lastIndexOf('.')
        );
        body.append('audioMediaKey', fileNameWithoutExtension);
      }
      if (audioValidationMsg === "") {
        onSaveHandler(body, dataToEdit?.category);
      }

      console.log("Form object:", form);
      console.log("form.mediaFile", form.mediaFile);
    } else {
      console.log("we don't have a media file");
      body.append('message', form.message);
      onSaveHandler(body, dataToEdit?.category);
    }

  };

  const onError = (errors: any) => {
    Object.entries(errors).forEach(([fieldName, errorDetails]) => {
      console.log(`Error in ${fieldName}:`, errorDetails);
    });
  };

  const audioFileHandler = (event: any) => {


    console.log("audioFileHandler triggered");
    const file = event.target.files[0];
    const audioType = file?.type;

    console.log("File object:", file);
    console.log("audioType =", audioType);


    if (!file) {
      setAudioValidationMsg("Please select a valid file.");
      setSelectedAudioFile("");
      setValue("mediaFile", null);
      return;
    }

    if (file?.size > FileSize.AudioSizeLimit) {
      setAudioValidationMsg("File size must be smaller than 3 MB");
      setSelectedAudioFile('');
      setValue('mediaFile', null);
      return
    }

    if ((audioType == AudioSupportedType.MP3) || (audioType == AudioSupportedType.WAV)) {
      setAudioValidationMsg("");
      setSelectedAudioFile(file.name);
      setValue('mediaFile', file);
    }
    else {
      setAudioValidationMsg("Please select only mp3 or wav files");
      setSelectedAudioFile('');
      setValue('mediaFile', null);
    }

  }

  const onButtonClickHandler = () => {
    const input = document.getElementById('file');
    if (input) {
      input.click();
    }
  }
  return (
    <Modal show={props.show} onHide={() => {
      // console.log("modal has been hidden");
      props.handleShow(false);
      setSelectedAudioFile('');
      reset();
    }} centered>
      <form onSubmit={handleSubmit(onEditHandler, onError)} encType="multipart/form-data">
        <Modal.Header closeButton>
          <Modal.Title>{dataToEdit?.title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div>
            <div className="col-xs-12 offset0">
              <label>
                <input
                  name="ivrMessageType"
                  type="radio"
                  value="message"
                  onClick={() => {
                    setDataToEdit({
                      ...dataToEdit,
                      isTtsEnabled: true,
                    });
                  }}
                  defaultChecked={dataToEdit?.isTtsEnabled ?? true}
                />
                Text message
              </label>
              {dataToEdit?.isTtsEnabled && (
                <div className="messageInputText">
                  <textarea
                    className="form-control"
                    id="message"
                    {...register('message', { required: true })}
                    rows={3}
                    cols={50}
                    maxLength={300}
                    defaultValue={dataToEdit?.message}
                    >
                    </textarea>
                </div>
              )}
            </div>
              <div className="col-xs-12 marginTop10 offset0">
                <label>
                  <input
                    name="ivrMessageType"
                    type="radio"
                    value="audio"
                    onClick={() => {
                      setAudioValidationMsg("")
                      setSelectedAudioFile('');
                      setDataToEdit({
                        ...dataToEdit,
                        isTtsEnabled: false,
                      });
                    }}
                    defaultChecked={!(dataToEdit?.isTtsEnabled ?? true)}
                  />
                  Audio message
                </label>
                {!dataToEdit?.isTtsEnabled && (
                  <div className="messageInputAudio">
                    <div className="col-xs-12 offset0 ">
                      <div className="input-group ">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Choose an audio file… e.g. mp3 or wav (file size < 3MB)"
                          aria-label="Upload file"
                          name="photo"
                          value={selectedAudioFile}
                          aria-describedby="photo"
                          readOnly
                        />
                        <input
                          className="d-none"
                          type="file"
                          id="file"
                          {...register('mediaFile')}
                          accept=".mp3, .wav"
                          onChange={audioFileHandler} />
                        <button
                            className="btn btn-primary"
                            type="button"
                            id="photo"
                            onClick={(e) => {
                              e.preventDefault()
                              onButtonClickHandler()
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faPaperclip}
                              className="me-2"
                            />
                            <label className="mb-0" htmlFor="file">
                              Browse
                            </label>
                          </button>

                      </div>
                      {audioValidationMsg && <FormErrorMessage message={audioValidationMsg} />}
                    </div>
                  </div>
                )}
              </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn text-uppercase"
            type="button"
            onClick={modalHideHandler}
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-primary text-uppercase btn-message-submit">
            Save
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
